export default function(){
    return(
        <>
        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          width={18}
                          height={18}
                          x={0}
                          y={0}
                          viewBox="0 0 64 64"
                          style={{ enableBackground: "new 0 0 512 512" }}
                          xmlSpace="preserve"
                        >
                          <g>
                            <path
                              d="M18.179 39.571A1.002 1.002 0 0 0 19 40h.01a1 1 0 0 0 .822-.445c.893-1.34 1.872-2.702 2.91-4.145C27.081 29.37 32 22.525 32 15a13 13 0 0 0-26 0c0 8.019 4.766 14.466 9.375 20.702.94 1.272 1.913 2.588 2.804 3.87ZM19 4a11.012 11.012 0 0 1 11 11c0 6.881-4.72 13.448-8.883 19.243a206.218 206.218 0 0 0-2.133 3.003c-.659-.917-1.338-1.836-2-2.733C12.565 28.538 8 22.36 8 15A11.012 11.012 0 0 1 19 4Z"
                              fill="#000000"
                              opacity={1}
                              data-original="#000000"
                            />
                            <path
                              d="M27 15a8 8 0 1 0-8 8 8.01 8.01 0 0 0 8-8Zm-14 0a6 6 0 1 1 6 6 6.007 6.007 0 0 1-6-6ZM2 62h60a1 1 0 0 0 .98-1.196l-5-25A1 1 0 0 0 57 35h-4v2h3.18l4.6 23H3.22l4.6-23H13v-2H7a1 1 0 0 0-.98.804l-5 25A1 1 0 0 0 2 62ZM39 33a5 5 0 1 0-5-5 5.006 5.006 0 0 0 5 5Zm0-8a3 3 0 1 1-3 3 3.003 3.003 0 0 1 3-3Z"
                              fill="#000000"
                              opacity={1}
                              data-original="#000000"
                            />
                            <path
                              d="M41 36a4.95 4.95 0 0 0 1.1 3.09 4.987 4.987 0 0 0-3.1 1.94 4.987 4.987 0 0 0-3.1-1.94A4.95 4.95 0 0 0 37 36a5 5 0 0 0-10 0 4.95 4.95 0 0 0 1.1 3.09A5.001 5.001 0 0 0 24 44v10a1 1 0 0 0 1 1h28a1 1 0 0 0 1-1V44a5.001 5.001 0 0 0-4.1-4.91A4.95 4.95 0 0 0 51 36a5 5 0 0 0-10 0Zm-9-3a3 3 0 1 1-3 3 3.003 3.003 0 0 1 3-3Zm6 20H26v-9a3.003 3.003 0 0 1 3-3h6a3.003 3.003 0 0 1 3 3Zm8-20a3 3 0 1 1-3 3 3.003 3.003 0 0 1 3-3Zm3 8a3.003 3.003 0 0 1 3 3v9H40v-9a3.003 3.003 0 0 1 3-3Z"
                              fill="#000000"
                              opacity={1}
                              data-original="#000000"
                            />
                          </g>
                        </svg>
        </>
    )
}
